import { render } from "./Table.vue?vue&type=template&id=99313112&scoped=true"
import script from "./Table.vue?vue&type=script&lang=ts"
export * from "./Table.vue?vue&type=script&lang=ts"

import "./Table.vue?vue&type=style&index=0&id=99313112&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-99313112"

export default script